import { i18n as designSystemI18n, registerLanguage } from "@st-marketplace/ui";

import { LANGUAGES, type Language } from "@/constants/language";

export function syncDesignSystemLanguage(lang: Language) {
	const language = LANGUAGES[lang];

	if (!language) return;

	registerLanguage(lang, language.mode);

	if (designSystemI18n.language !== lang) {
		return designSystemI18n.changeLanguage(lang);
	}
}

export function applyDocumentLanguage(lang: Language) {
	const language = LANGUAGES[lang];

	if (!language || typeof document === "undefined") return;

	document.documentElement.lang = lang;
	document.documentElement.dir = language.mode;
}
